import React, { useState } from "react";
import Layout from "../../components/Layout/layout";
import { useNavigate } from "react-router-dom";
// import { useLocation } from "react-router-dom";
import { baseURL } from "../axiosInstance";
import axios from "axios";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Cookies from 'universal-cookie';



const cookies = new Cookies();
const AdminRegistration = ({ admin, setAdmin }) => {



    const navigate = useNavigate();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [emailError, setEmailError] = useState('');

    const validateEmail = (value) => {
        // Regular expression for basic email validation
        const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return re.test(value);
    };

    const handleChange = (e) => {
        const { value } = e.target;
        setEmail(value);

        if (!validateEmail(value)) {
            setEmailError('Please enter a valid email address');
        } else {
            setEmailError('');
        }
    };



    const handleAdminRegisteration = async (e) => {
        e.preventDefault();
        try {
            const response = await axios.post(`${baseURL}/user/admin`, {
                email,
                password
            }, {
                headers: {
                    'Content-Type': 'application/json',
                }
            });

            if (response.data.success == true) {


                const token = response.data.token; // Assuming your API response contains a token
                cookies.set('token', token, { path: '/' });

                setAdmin(true);

                setTimeout(() => {
                    navigate("/adminPanel")
                }, 1000)


            }

        }
        catch (error) {
            console.log(error);
        }

    }

    // const navigate = useNavigate();
    // const location = useLocation();





    return (
        <Layout>
            <div className="bg-[#D7DDE1] py-10 ">
                <div className="w-full md:w-3/4 px-10 md:px-20 py-8 border-2 bg-[#f5f4f4] z-20 mb-[5vh] relative mx-auto">
                    <div className="font-bold text-4xl text-[#1F7E95] mb-10">
                        Admin Registration
                    </div>

                    <div className="text-lg mb-10 text-gray-500">
                        Register Only If You Are Admin Of This Page
                    </div>




                    <div className="w-full mt-[3rem]">
                        <ToastContainer style={{ marginTop: '50px' }} />
                        <form>
                            <div className="w-full">
                                <input
                                    value={email}
                                    onChange={handleChange}
                                    type="email"
                                    name=""
                                    id=""
                                    className={`w-full bg-neutral-200 p-3 border-0 outline-none rounded-md text-gray-600 placeholder-gray-500 ${emailError ? 'border-red-500' : ''
                                        }`}
                                    placeholder="Email address"
                                />
                                {emailError && <p className="text-red-500 text-sm mt-1">{emailError}</p>}
                            </div>

                            <div className="w-full mt-2">
                                <input
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    type="password"
                                    name=""
                                    id=""
                                    className={`w-full bg-neutral-200 p-3 border-0 outline-none rounded-md text-gray-600 placeholder-gray-500 ${emailError ? 'border-red-500' : ''
                                        }`}
                                    placeholder="Password"
                                />

                            </div>

                            <button type="submit" onClick={handleAdminRegisteration} className="p-4 text-center rounded-lg mt-3 bg-green-300 text-green-950">Submit</button>
                        </form>
                    </div>
                </div>
            </div>
        </Layout>
    );
};

export default AdminRegistration;
